import { Component, OnInit } from '@angular/core';
import { RoutePrefix, AEMRoutes } from '../../core/constants/routes.constant';
import { BaseComponent } from '../../app.base.component';
import { Router } from '@angular/router';
import { Footer } from '../../shared/models/footer';
import { StaticConstants } from '../../core/constants/static.constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PublisherService } from '../../core/services/publisher.service';
import { StaticService } from '../../core/services/static/static.service';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../core/services/init/app-config.service';
import { CacheConstant, CMSPages } from '../../core/constants/app.constant';
import { StaticPageContent } from '../../shared/models/cms';
import { AuthService } from '../../core/services/auth.service';
import { CmsService } from '../../core/services/cms.service';

@Component({
  selector: 'par-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends BaseComponent implements OnInit {
  /***************Properties***************/
  websiteName: string = this.appConfig.configLoaded ? this.cache.get(CacheConstant.Env_Properties).theme : 'Parmed';
  entity = `${this.websiteName + 'Footer'}`;
  footerData: Footer;
  supportId: string;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  //cmsContentFlag = this.envProperties != undefined ? (this.envProperties.cmsContentFlag ? this.envProperties.cmsContentFlag.toBoolean() : false) : false;
  cmsPageName: any;
  templateNum: any;
  buId = this.envProperties.buId;
  cmsPageConfigVO = this.envProperties.cmsPageConfigVO;
  routes = {
    contactUs: RoutePrefix.ContactUs,
    employment: AEMRoutes.Employment,
    help: AEMRoutes.Help,
    productservices: AEMRoutes.ProductServices,
    majorProductservices: AEMRoutes.MajorProductServices,
    legal: AEMRoutes.Legal,
    majorLegal: AEMRoutes.MajorLegal,
    privacy: AEMRoutes.Privacy,
    majorPrivacy: AEMRoutes.MajorPrivacy,
    majorNews: AEMRoutes.Major.News,
    majorHelp: AEMRoutes.Major.Help,
    productCatalogList:AEMRoutes.Major.ProductCatalogList,
    packageInsert: RoutePrefix.PackageInsert,
    MajorAmazon :RoutePrefix.Amazon,
    majorAboutUs:AEMRoutes.Major.AboutUs,
    mobile: {
      legal: AEMRoutes.Mobile.Legal,
      majorLegal: AEMRoutes.Mobile.MajorLegal,
      privacy: AEMRoutes.Mobile.Privacy,
      majorPrivacy: AEMRoutes.Mobile.MajorPrivacy,
    }
  };
  /***************Properties***************/

  /***************Constructor***************/

  constructor(
    deviceDetectorService: DeviceDetectorService,
    private router: Router,
    private staticService: StaticService,
    private cache: AppCacheService,
    private appConfig: AppConfigService,
    private cmsService: CmsService
  ) {
    super(deviceDetectorService, cache, appConfig);
    this.footerData = super.getFooterData();
  }

  ngOnInit() {
    PublisherService.staticDataLoaded$.subscribe(staticData => {
      this.footerData.WeekWorkingTime = this.staticService.masterEntity
        .get(StaticConstants.MasterEntityKey.WorkingHours)
        .value.split(',')[0];
      this.footerData.WeekendWorkingTime = this.staticService.masterEntity
        .get(StaticConstants.MasterEntityKey.WorkingHours)
        .value.split(',')[1];
    });
    this.getFooterDetails();
    // if(this.cmsContentFlag){
    //   this.getFooterDetails();
    // }
  }
  onPrivacyClick() {
    this.router.navigate(['privacy']);
  }

  onAboutUsClick() {
    this.onClick();
    this.router.navigate([AEMRoutes[this.websiteName].AboutUs]);
  }
  onClick(){
    window.scrollTo(0, 0);
  }

  onLegalClick() {
    this.router.navigate(['legal']);
  }

  getFooterDetails() {
    this.cmsPageName = CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let sequenceNumber: number = this.cmsPageConfigVO.footerSeqNo;
    this.cmsService
      .getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, sequenceNumber)
      .subscribe((res: any) => {

        if (res.length > 0) {
          let staticPageContent: StaticPageContent = res[0];
          this.parseContentToFooterData(staticPageContent);
        }
      });
  }

  parseContentToFooterData(staticPageContent: StaticPageContent) {
    let leftWidget = document.getElementById("footer-left-widget");
    let rightWidget = document.getElementById("footer-right-widget");
    let processedData: string[] = this.cmsService.prepareFooterStaticContents(staticPageContent);
    leftWidget.innerHTML = processedData[0];
    if(this.isHTML(processedData[1])){
      let splitByDivTag=processedData[1].split("<div>").filter(item=>item);
      rightWidget.innerHTML = '© '+new Date().getFullYear()+" "+splitByDivTag[0];
    }
    else{
      rightWidget.innerHTML = '© '+new Date().getFullYear()+" "+processedData[1];
    }
  }
   isHTML(str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }
  routeClick(route) {
     this.onClick();
    this.router.navigate([route]);
    if (this.router.url == '/' + route || this.router.url == route) {
      this.reload()
    }
  }
  reload() {
    window.location.reload();
  }
}
